
















































import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'MultiSliderPollAnswers',
  props: {
    poll: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getPollAnswers: 'presenter/getPollAnswers',
    }),
    pollAnswer(): any {
      if (this.poll.id in this.getPollAnswers) {
        return this.getPollAnswers[this.poll.id];
      }
      return {};
    },
  },
  methods: {},
});
